import React from 'react';
import './TermsAndPrivacy.css';

function TermsAndPrivacy_v1_0_2() {
  const version = '1.0.2';
  return (
    <div className="terms-and-privacy">
      <div className="content">
        <p>2025年8月10日 制定・施行</p>
        <p>2025年10月27日 改定 (v: {version})</p>
        <p>
          本ページは、感情記録アプリ「EmotionLog」（以下「本アプリ」）の「利用規約」および「プライバシーポリシー」です。
        </p>

        <h2>1. 本規約の適用</h2>
        <ul>
          <li>本規約は、開発者（以下「当方」）が提供する本アプリの利用条件を定めるものです。ユーザーは本アプリをダウンロード、インストール、または利用することにより、本規約に同意したものとみなされます。</li>
        </ul>

        <h2>2. アプリの目的</h2>
        <ul>
          <li>日々の感情を簡単に記録・振り返りできるようにすることを目的としています。記録データはユーザーごとに保存し、グラフやカレンダーでの可視化、通知によるリマインド等の機能を提供します。</li>
          <li>本アプリは医療行為や専門的助言を目的とするものではありません。</li>
        </ul>

        <h2>3. 収集する情報</h2>
        <ul>
          <li>
            アカウント情報（Firebase）<br />
            ユーザーID（UID）、表示名、メールアドレス、認証プロバイダ（Apple）。
          </li>
          <li>
            感情記録データ（Firebase）<br />
            感情タイプ、任意のメモ、作成日時・更新日時など、アプリ機能に必要な情報。
          </li>
          <li>
            アプリ設定（端末ローカル）<br />
            リマインドの有効/無効、通知時刻の設定。
          </li>
          <li>
            利用状況・クラッシュ情報（必要に応じて）<br />
            Firebase 関連サービスを用いた匿名化データ。<br />
            詳細は <a href="https://firebase.google.com/support/privacy?hl=ja">Firebase プライバシー</a> をご確認ください。
          </li>
          <li>
            広告配信のための情報（AdMob）<br />
            広告識別子（IDFA）、アプリ使用状況、デバイス情報等。<br />
            詳細は <a href="https://policies.google.com/privacy?hl=ja">Google プライバシーポリシー</a> をご確認ください。
          </li>
        </ul>

        <h2>4. 利用目的</h2>
        <ul>
          <li>本アプリの提供、維持、改善</li>
          <li>感情記録・履歴表示・統計のためのデータ保存と表示</li>
          <li>通知機能（リマインド）の提供</li>
          <li>広告配信の最適化およびパーソナライゼーション</li>
        </ul>

        <h2>5. データの保存場所・期間</h2>
        <ul>
          <li>アカウント情報と感情記録は Firebase に保存されます。</li>
          <li>端末ローカルの設定はユーザー端末上に保存されます。</li>
          <li>広告関連データは Google（AdMob）のサーバーに保存されます。</li>
          <li>アカウント削除時、関連データは原則削除。</li>
        </ul>

        <h2>6. 禁止事項</h2>
        <ul>
          <li>法令・公序良俗に反する行為</li>
          <li>不正アクセス、リバースエンジニアリング</li>
          <li>第三者への誹謗中傷や迷惑行為</li>
          <li>脆弱性の悪用や負荷試験</li>
          <li>
            個人情報や機密情報、第三者のプライバシーに関する内容を投稿・保存しないでください。
          </li>
        </ul>

        <h2>7. 第三者サービスの利用</h2>
        <p>本アプリでは以下の第三者サービスを利用しています。</p>
        <ul>
          <li>
            <strong>Firebase（Google Inc.）</strong><br />
            認証、データベース、分析等のサービス提供<br />
            <a href="https://firebase.google.com/support/privacy?hl=ja">Firebase プライバシーポリシー</a>
          </li>
          <li>
            <strong>AdMob（Google Inc.）</strong><br />
            広告配信サービス<br />
            <a href="https://policies.google.com/privacy?hl=ja">Google プライバシーポリシー</a>
          </li>
        </ul>

        <h2>8. 第三者提供</h2>
        <p>以下の場合を除き、個人情報を第三者に提供しません。</p>
        <ul>
          <li>ユーザーの同意がある場合</li>
          <li>法令に基づく開示要求がある場合</li>
          <li>上記第三者サービスへのデータ提供（各サービスのプライバシーポリシーに基づく）</li>
        </ul>

        <h2>9. ユーザーの権利</h2>
        <ul>
          <li>プロフィール情報の確認・更新</li>
          <li>感情記録の作成・編集・削除</li>
          <li>アカウント削除（認証プロバイダ仕様に基づく再認証を含む）</li>
          <li>広告のパーソナライゼーションのオプトアウト（端末設定より）</li>
        </ul>

        <h2>10. 安全管理措置</h2>
        <ul>
          <li>通信の暗号化（TLS）</li>
          <li>Firebase によるアクセス制御</li>
          <li>必要最小限の情報保存</li>
        </ul>

        <h2>11. 免責事項</h2>
        <ul>
          <li>当方は、本アプリの利用または利用不能により生じた損害について、当方の故意または重大な過失による場合を除き、一切の責任を負いません。</li>
          <li>本アプリの提供する情報、機能、サービスは、現状のまま提供されるものであり、その正確性、完全性、有用性等について保証するものではありません。</li>
          <li>本アプリからリンクされている外部サイトの内容や、それらの利用によって生じたトラブル・損害についても、当方は一切の責任を負いません。</li>
          <li>ユーザーは、本アプリの利用にあたり自己の責任において行動するものとし、その利用により生じた損害については自己責任で対処するものとします。</li>
        </ul>

        <h2>12. 規約・ポリシーの変更</h2>
        <ul>
          <li>
              本ページの内容は、法令改正や機能追加等に応じて予告なく変更する場合があります。
          </li>
        </ul>

        <h2>13. お問い合わせ</h2>
        <p>
          本アプリのデータ取扱いに関するお問い合わせは以下までご連絡ください。<br />
          Mail: <a href="mailto:developer.poteto.contact@gmail.com">メールリンク</a>
        </p>
      </div>
    </div>
  );
}

export default TermsAndPrivacy_v1_0_2;


